export type InstalledPwaRole = 'agent' | 'courier' | 'customer'

const PWA_ROLE_STORAGE_KEY = '3asass.installedPwaRole'

export function setInstallManifestForRole(role: InstalledPwaRole) {
  if (typeof document === 'undefined') return

  const manifestHref = {
    agent: '/manifest-agent.webmanifest',
    courier: '/manifest-courier.webmanifest',
    customer: '/manifest-customer.webmanifest'
  }[role]
  let link = document.querySelector<HTMLLinkElement>('link[rel="manifest"]')

  if (!link) {
    link = document.createElement('link')
    link.rel = 'manifest'
    document.head.appendChild(link)
  }

  link.href = manifestHref
}

export function captureInstalledPwaRoleFromUrl() {
  if (!isStandaloneApp()) return

  const role = roleFromUrl()
  if (role) {
    localStorage.setItem(PWA_ROLE_STORAGE_KEY, role)
  }
}

export function getInstalledPwaRole() {
  if (!isStandaloneApp()) return null

  const role = localStorage.getItem(PWA_ROLE_STORAGE_KEY)
  return isInstalledPwaRole(role) ? role : roleFromUrl()
}

export function loginRouteForInstalledRole(role: InstalledPwaRole) {
  if (role === 'agent') return { name: 'agent-login' }
  if (role === 'courier') return { name: 'courier-login' }
  return { name: 'user-login' }
}

function roleFromUrl() {
  const role = new URLSearchParams(window.location.search).get('pwa_role')
  return isInstalledPwaRole(role) ? role : null
}

function isInstalledPwaRole(role: string | null): role is InstalledPwaRole {
  return role === 'agent' || role === 'courier' || role === 'customer'
}

function isStandaloneApp() {
  return window.matchMedia('(display-mode: standalone)').matches || Boolean((window.navigator as { standalone?: boolean }).standalone)
}
